import { render, staticRenderFns } from "./checkTic.vue?vue&type=template&id=37051a6f&"
import script from "./checkTic.vue?vue&type=script&lang=js&"
export * from "./checkTic.vue?vue&type=script&lang=js&"
import style0 from "./checkTic.vue?vue&type=style&index=0&id=37051a6f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports